import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimpleTable from 'components/shared/table/SimpleTable';
import './PurchaseOrders.css';
import { getCurrentUser } from 'selectors/authentication';
import {
  changePage,
  getPurchaseOrders,
  setShowCreateModal,
} from 'components/admin/purchase-orders/store/actions';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import {
  currentPageSelector,
  purchaseOrdersSelector,
} from 'components/admin/purchase-orders/store/selectors';
import Number from 'components/shared/text/Number';
import DocumentLink from 'components/shared/document/DocumentLink';
import NewPurchaseOrderModal from 'components/admin/purchase-orders/NewPurchaseOrderModal';

class PurchaseOrders extends Component {
  componentDidMount() {
    this.props.dispatch(getPurchaseOrders());
  }

  handleAddPurchaseOrder = () => {
    this.props.dispatch(setShowCreateModal(true));
  };

  handlePageChange = (newPage) => {
    this.props.dispatch(changePage(newPage));
  };

  mapPurchaseOrders = (purchaseOrders) => {
    return purchaseOrders.map((purchaseOrder) => [
      purchaseOrder.number,
      <Number value={purchaseOrder.amount} format="$0,0" />,
      <Number value={purchaseOrder.balance} format="$0,0" />,
      purchaseOrder.document !== null ? (
        <DocumentLink
          showIcon={false}
          showLink={true}
          url={purchaseOrder.document.document.url}
        />
      ) : (
        'N/A'
      ),
    ]);
  };

  render() {
    return (
      <div className="purchase-orders">
        <div className="full-title">Purchase Orders</div>
        <div className="content-container">
          <SearchBar
            addButton={
              <input
                className={'btn button button-orange'}
                type="button"
                value="Add Purchase Order"
                onClick={this.handleAddPurchaseOrder}
              />
            }
          >
            &nbsp;
          </SearchBar>
          {this.props.purchaseOrders !== null && (
            <div>
              <SimpleTable
                className="purchase-orders-table"
                headers={['PO #', 'AMOUNT', 'BALANCE', 'DOCUMENT']}
                rows={this.mapPurchaseOrders(this.props.purchaseOrders.content)}
                emptyMessage="No Purchase Orders"
              />
              <div className="pagination-container">
                <SimplePagination
                  currentPage={this.props.currentPage}
                  pageSize={this.props.purchaseOrders.pageSize}
                  total={this.props.purchaseOrders.total}
                  onPageChange={this.handlePageChange}
                />
              </div>
            </div>
          )}
        </div>
        <NewPurchaseOrderModal />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentPage: currentPageSelector(state),
    currentUser: getCurrentUser(state),
    purchaseOrders: purchaseOrdersSelector(state),
  };
})(PurchaseOrders);



// WEBPACK FOOTER //
// ./src/components/admin/purchase-orders/PurchaseOrders.js